import ReduxableService from './parentСlasses/ReduxableService'


import { setUser } from '../actions/service';
import { setPaletteWidth } from '../actions/ui'
import * as actions from '../actions/user';

const makeFullRight = () => {
  const right = [
    'dirProjects',
    'dirWorkers',
    'dirCompanies',
    'dirWork_positions',
    'dirTrackers',
    'dirActivities',
    'dirUsers',
    'trackerDetails',
    'trackersDetails',
    'routePeriod',
    'getExcel',
    'geoZones',
    'table',
    'plan',
    'order',
    'reportGeozones',
    'reportRoute',
    'reportActivity',
  ]
  const actions = [
    'view',
    'create',
    'edit',
    'delete',
    'approve',
  ]
  let fullRight = []
  right.forEach((r) => {
    actions.forEach((a) => {
      fullRight.push(`${r}-${a}`)
    })
  })
  return fullRight;
}

export default class UserService extends ReduxableService {

  constructor(store) {
    super(store, actions, setUser)

    //пытаемся восстановить пользователя из локального хранилища:
    if (localStorage.getItem("userId") && localStorage.getItem("userJwt")) {
      const user = {
        userId: localStorage.getItem("userId"),
        userJwt: localStorage.getItem("userJwt"),
        userName: localStorage.getItem("userName") ? localStorage.getItem("userName") : ''
      };
      this.actions.setUser(user);
      this._checkLogin();
    }
  }

  restoreSettings = () => {
    //ф-ция предназначена для чтения из локального хранилища настроек текущего пользователя
    //и заначивания их в редакс. По политическим мотивам она отделена от _postLoginActions
    const { user: { data: { userId } = {} } = {} } = this.store.getState()['api']

    if (userId) {
      const _settings = localStorage.getItem(`settings_${userId}`) || '{}'
      const settings = JSON.parse(_settings);
      this.actions.setUserSettings(settings);

      // //по возможности восстанавливаем положение на карте
      // if(settings?.curBounds && this.rr.ui_mapControl){
      //   this.rr.ui_mapControl.fitBounds(settings.curBounds);
      // }

      //по возможности восстанавливаем настройки 
      if (settings?.paletteWidth) {
        //нашли- восстанавливаем.
        //но перед этим экранируем слежение за редаксом в части касающейся фильтров
        this.__ui_paletteWidth = settings.paletteWidth;
        this._bindAC(setPaletteWidth)(this.__ui_paletteWidth);
      }
    }
  }
  setSettings = (settings) => {
    //ф-ция почти обратна ф-ции restoreSettings. Получает settings и сует в локалСторадж и редакс
    const { user: { data: { userId } = {} } = {} } = this.store.getState()['api']
    if (userId && settings) {
      localStorage.setItem(`settings_${userId}`, JSON.stringify(settings))
    }
    if (settings) {
      this.actions.setUserSettings(settings)
    }
  }
  updateSettings = (updatedSettingsFragment) => {
    //ф-ция обновляет в настройках пользователя те поля, которые есть в переданном ей объекте
    const { userSettings = {} } = this.store.getState()['api'];
    this.setSettings({ ...userSettings, ...updatedSettingsFragment });
  }

  //внутренние функции
  _storeListener = () => {
    if (this._isLoginAction) {
      this._onLoginAction();
    }
    if (this._isChange('api_rights')) {
      if (!this.rr.api_rights?.loading && !this.rr.api_rights?.error) {

        if (this.rr.api_rights?.data?.rights && Array.isArray(this.rr.api_rights.data.rights)) {
          this.actions.setUserRights(this._buildRightObj(this.rr.api_rights.data.rights))
          // this.actions.setUserRights(this._buildRightObj(makeFullRight()))
          // this.actions.setUserRolename("test-123 (Суперадмин)")
        }
        if (this.rr.api_rights?.data?.name) {
          this.actions.setUserRolename(this.rr.api_rights.data.name)
        }
        if (this.rr.api_rights?.data?.role){
          this.actions.setUserRole(this.rr.api_rights.data.role)
        }
      }
    }
  }
  _buildRightObj = (right) => {
    const rightObj = {}
    right.forEach((r) => {
      rightObj[r] = true;
    })
    return rightObj;
  }

  get _checkLogin() {
    return (this.rr.service_Api.checkLogin) || (() => { console.log('debug не получилось обратится к апи для проверки логина') })
  }

  get _isLoginAction() {
    //проверка логин ли это произошол
    const result = (this.loading !== this.rr.api_user?.loading);
    this.loading = this.rr.api_user?.loading;
    return result;
  }
  _onLoginAction = () => {
    // Действия при изменении статуса залогинености пользователя
    if (!this.rr.api_user?.loading) {
      //Только что завершилась загрузка пользователя (бывает при логине, чекЛогине и логауте)
      const {
        error,
        data: {
          userId,
          userJwt,
          userName
        } = {}
      } = this.rr.api_user;
      if (!error && userId && userJwt) {
        //Логин прошел успешно
        localStorage.setItem('userId', userId);
        localStorage.setItem('userJwt', userJwt);
        localStorage.setItem('userName', userName);

        const user = {
          userId,
          userJwt,
          userName
        };
        this.actions.setUser(user);
        this.actions.setUserName(userName);

        this.restoreSettings();
        this.actions.setIsLoggedIn(true);
        this.rr.service_Api.getRights();
      } else {
        //Логин не удался, или это был логаут
        localStorage.removeItem('userId');
        localStorage.removeItem('userJwt');
        localStorage.removeItem('userName');
        if (this.rr.user_isLoggedIn) {
          //До этого мы были залогинены, значит надо почистить за собой
          this.actions.makeReset()
        }
        this.actions.setIsLoggedIn(false);
      }
    }
  }
}
